const en = {
    common: {
        history: "historic version"
    }
};
export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js